import '../../client/index.js';
import { wrapErrorManager } from '../../utils/error-manager.js';
import { transformGetCoreGeolocationGeocountriesResponse } from './transformers.js';
import defaultClient from 'axios';

const getCoreGeolocationGeocountries = async ({ client , controller  } = {})=>await client.get(`/V1/core/geolocation/geocountries`, {
        signal: controller?.signal,
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformGetCoreGeolocationGeocountriesResponse)
        ]
    });
getCoreGeolocationGeocountries.key = 'getCoreGeolocationGeocountries';

export { getCoreGeolocationGeocountries };
